'use strict';

angular.module('study.ecrd.field.queries').controller('FieldQueriesController', [
    '$window',
    '$rootScope',
    '$exceptionHandler',
    '$stateParams',
    'RecordService',
    'RecordDataService',
    'RecordQueriesService',
    'Event',
    'Modal',
    'InetsysMessages',
    'gettext',
    'RecordsManagerService',
    'ErrorMessages',
    'AccountManager',
    'StudyContext',
    function(
        $window,
        $rootScope,
        $exceptionHandler,
        $stateParams,
        RecordService,
        RecordDataService,
        RecordQueriesService,
        Event,
        Modal,
        InetsysMessages,
        gettext,
        RecordsManagerService,
        ErrorMessages,
        AccountManager,
        StudyContext
    ) {
        var vm = this;

        // Permisos generales, a.k.a routes
        vm.permission = {
            read: AccountManager.hasPermission('read records queries'),
            create: AccountManager.hasPermission('create records queries'),
            reply: AccountManager.hasPermission('reply records queries'),
            close: AccountManager.hasPermission('close records queries'),
        };
        // Permisos según el ámbito del registro que estamos viendo
        vm.context = {
            read: StudyContext.canWithQueries('read'),
            create: StudyContext.canWithQueries('create'),
            reply: StudyContext.canWithQueries('reply'),
            close: StudyContext.canWithQueries('close'),
        };

        vm.queries = [];
        vm.error = null;

        var listIndices = RecordDataService.getCRF().getListIndices($stateParams);

        vm.$onInit = function() {
            var fieldUid = RecordDataService.getElementUID(vm.fieldId, listIndices);
            var fieldLabel = RecordDataService.getElementFullLabeledPathByUID(fieldUid);
            vm.queries = RecordQueriesService.getFieldQueries(vm.fieldId, listIndices);

            for (var queriesIndex = 0; queriesIndex < vm.queries.length; queriesIndex++) {
                vm.queries[queriesIndex].firstText = vm.queries[queriesIndex].texts[0];
                vm.queries[queriesIndex].lastText = vm.queries[queriesIndex].texts[vm.queries[queriesIndex].texts.length - 1];

                for (var textIndex = 0; textIndex < vm.queries[queriesIndex].texts.length; textIndex++) {
                    vm.queries[queriesIndex].texts[textIndex].labelChanged = vm.queries[queriesIndex].texts[textIndex].fieldLabel && !$window._.isEqual(vm.queries[queriesIndex].texts[textIndex].fieldLabel, fieldLabel);
                }
            }
        };

        var expandedQueries = {};
        vm.isExpanded = function(queryId) {
            return expandedQueries[queryId];
        };

        vm.toggleExpand = function(queryId) {
            expandedQueries[queryId] = !expandedQueries[queryId];
        };

        // Crear nueva nota de discrepancia
        vm.createQuery = function() {
            // Allow others to stop this action before it is launched
            return Event.broadcast('discrepancyNotesActionStart', [vm.fieldId, 'create'])
                .then(function(event) {
                    if (!event.defaultPrevented) {
                        // Open form in modal
                        return Modal.open({
                            controller: 'FieldCreateQueryController',
                            controllerAs: '$ctrl',
                            templateUrl: 'modules/ecrd/components/field/queries/create-modal/content.html',
                            onlyActions: true,
                        }).closePromise
                            // 'Submit' button pressed - Call server to create note
                            .then(function(queryData) {
                                var fieldUId = RecordDataService.getElementUID(vm.fieldId, listIndices);
                                var params = {
                                    recordId: RecordService.getId(),
                                    fieldUId: fieldUId.join('.'),
                                    text: queryData.text,
                                };

                                return RecordsManagerService.createQuery(params);
                            })
                            // Error
                            .catch(function(error) {
                                // 'Cancel' button pressed - nothing to do
                                if (error !== Modal.DISMISSED) {
                                    InetsysMessages.error({
                                        mode: 'modal',
                                        title: gettext('No se ha podido crear la nota de discrepancia'),
                                        body: ErrorMessages.get(error),
                                    });
                                }

                                throw error;
                            })
                            // Successfull call
                            .then(function() {
                                // TODO recargar de nuevo las notas? Añadirla al core de Queries?
                                // initNotesData();

                                // Success message
                                InetsysMessages.success({
                                    title: gettext('Nueva nota de discrepancia creada'),
                                });

                                return RecordsManagerService.getQueries(RecordService.getId());
                            })
                            .then(function(recordQueries) {
                                RecordQueriesService.load(recordQueries);
                                vm.queries = RecordQueriesService.getFieldQueries(vm.fieldId, listIndices);
                                // Trigger event: info updated
                                $rootScope.$broadcast('EntityNotesUpdated');
                            });
                    }
                })
                .catch($exceptionHandler);
        };

        // Responder a una nota de discrepancia
        vm.replyNote = function(query) {
            // Allow others to stop this action before it is launched
            return Event.broadcast('discrepancyNotesActionStart', [vm.fieldId, 'reply'])
                .then(function(event) {
                    if (!event.defaultPrevented) {
                        // Open form in modal
                        return Modal.open({
                            controller: 'FieldReplyQueryController',
                            controllerAs: '$ctrl',
                            templateUrl: 'modules/ecrd/components/field/queries/reply-modal/content.html',
                            onlyActions: true,
                            resolve: {
                                query: function() {
                                    return query;
                                },
                            },
                        }).closePromise
                            // 'Submit' button pressed - Call server to reply note
                            .then(function(queryData) {
                                // var fieldUId = RecordDataService.getElementUID(vm.fieldId, listIndices);
                                var params = {
                                    queryId: query.id,
                                    status: queryData.status,
                                    text: queryData.text,
                                };

                                return RecordsManagerService.replyQuery(params);
                            })
                            // Error in server call
                            .catch(function(error) {
                                // Error message
                                if (error !== Modal.DISMISSED) {
                                    InetsysMessages.error({
                                        mode: 'modal',
                                        title: gettext('No se ha podido responder la nota de discrepancia'),
                                        body: ErrorMessages.get(error),
                                    });
                                }

                                throw error;
                            })
                            // Query replied
                            .then(function(response) { // eslint-disable-line no-unused-vars
                                // initNotesData();
                                // Success message
                                InetsysMessages.success({
                                    title: gettext('Nota de discrepancia actualizada'),
                                });

                                return RecordsManagerService.getQueries(RecordService.getId());
                            })
                            .then(function(recordQueries) {
                                RecordQueriesService.load(recordQueries);
                                vm.queries = RecordQueriesService.getFieldQueries(vm.fieldId, listIndices);
                                // Trigger event: info updated
                                $rootScope.$broadcast('EntityNotesUpdated');
                            });
                    }
                })
                .catch($exceptionHandler);
        };

        // Cerrar una nota de discrepancia
        vm.closeNote = function(query) {
            // Allow others to stop this action before it is launched
            return Event.broadcast('discrepancyNotesActionStart', [vm.fieldId, 'close'])
                .then(function(event) {
                    if (!event.defaultPrevented) {
                        // Open form in modal
                        return Modal.open({
                            controller: 'FieldCloseQueryController',
                            controllerAs: '$ctrl',
                            templateUrl: 'modules/ecrd/components/field/queries/close-modal/content.html',
                            onlyActions: true,
                            resolve: {
                                query: function() {
                                    return query;
                                },
                            },
                        }).closePromise
                            // 'Submit' button pressed - Call server to close note
                            .then(function(data) {
                                // var fieldUId = RecordDataService.getElementUID(vm.fieldId, listIndices);
                                var params = {
                                    queryId: query.id,
                                    // status: 'closed',
                                    text: data.text,
                                };

                                return RecordsManagerService.closeQuery(params);
                            })
                            // Error in server call
                            .catch(function(error) {
                                if (error !== Modal.DISMISSED) {
                                    // Error message
                                    InetsysMessages.error({
                                        mode: 'modal',
                                        title: gettext('No se ha podido responder la nota de discrepancia'),
                                        body: ErrorMessages.get(error),
                                    });
                                }

                                throw error;
                            })
                            // Query closed
                            .then(function(response) { // eslint-disable-line no-unused-vars
                                // initNotesData();

                                // Success message
                                InetsysMessages.success({
                                    title: gettext('Nota de discrepancia actualizada'),
                                });

                                return RecordsManagerService.getQueries(RecordService.getId());
                            })
                            .then(function(recordQueries) {
                                RecordQueriesService.load(recordQueries);
                                vm.queries = RecordQueriesService.getFieldQueries(vm.fieldId, listIndices);
                                // Trigger event: info updated
                                $rootScope.$broadcast('EntityNotesUpdated');
                            });
                    }
                })
                .catch($exceptionHandler);
        };
    },
]);
